import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { MEMBERSHIPS_REQUEST_APPROVAL, MEMBERSHIPS_REQUEST_APPROVAL_SUCCESS, MEMBERSHIPS_REQUEST_APPROVAL_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* membershipsRequestApproval({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { id } = payload.data;
    const action = payload.data.status === 'accept' ? 'approve' : 'reject';

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/program-management/membership-request/${id}/action`,
      method: 'POST',
      data: { action },
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: MEMBERSHIPS_REQUEST_APPROVAL_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: MEMBERSHIPS_REQUEST_APPROVAL_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: MEMBERSHIPS_REQUEST_APPROVAL_ERROR, payload: error });
  }
}

export function* watchMembershipsRequestApproval() {
  yield takeEvery(MEMBERSHIPS_REQUEST_APPROVAL, membershipsRequestApproval);
}

function* membershipsRequestApprovalSaga() {
  yield all([fork(watchMembershipsRequestApproval)]);
}

export default membershipsRequestApprovalSaga;
